import DeleteTemplate from './DeleteTemplate';
export default DeleteTemplate;
